// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2n4C3","primary":"Button_primary__1qc12"};